var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 172.431399999999485 132.083299999998417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#fff;}.cls-1,.cls-2,.cls-3{fill:none;}.cls-1,.cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:3.5px;}.cls-2{stroke-width:0px;}.cls-3{stroke:#e8ba3a;}.cls-4{clip-path:url(#clippath);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.91438038e-7,
    y: -0.000003893655958,
    width: 172.43139881712523,
    height: 132.08330778731033
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2369",
    className: "cls-1",
    d: "m76.186987002549358,29.905047991942411c-1.229732915744535-.76605082149581-2.785843945568558-.76605082149581-4.015576950760078,0-6.004607989267242,3.740968990443434-9.916643916982139,9.833361169035925-9.916643916982139,16.718815590216764,0,6.884702392102554,3.912036643256215,12.977846599767872,9.916643916982139,16.718815590220402,1.229732826310283.765300849576306,2.785843945561282.765300849576306,4.015576950760078,0,6.005357871748856-3.740968990452529,9.916643916985777-9.834111767044305,9.916643916985777-16.718815590220402,0-6.885454421180839-3.91128604523692-12.977846599773329-9.916643916985777-16.718815590216764Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2373",
    className: "cls-1",
    d: "m115.575002884846981,67.65473431922328c.10852276339574-1.435029148813555-.608464992557856-2.80420710632643-1.848574675392229-3.533838426536022-6.057782451716776-3.563339631631607-13.220812705987555-4.201306206088702-19.281227381623466-1.030966134481787-6.060417690074246,3.170339820399022-9.622175751637769,9.418300921553964-10.149513811835277,16.426447337091304-.10799691835382,1.434502126261577.608464364562678,2.804207106328249,1.848574047402508,3.533838426543298,6.057783079715591,3.563339631624331,13.221338849329186,4.201305201268042,19.281228009636834,1.03096663688666,6.060418192471843-3.169813049062213,9.622177447246941-9.418300419154548,10.14951381181163-16.426447839503453Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2375"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2377",
    className: "cls-1",
    d: "m74.668824833161125,85.575534754327236l23.093750333677235-10.712671318846333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2381",
    className: "cls-3",
    d: "m32.783351465079249,79.644811837615634c-.107995952796045-1.435029148817193.608464992559675-2.804733877675972,1.848574675421332-3.533838426537841,6.057782451713138-3.563339631627969,13.221339226123746-4.201306206085064,19.28122738159982-1.030966134485425,6.060417690094255,3.170339820404479,9.62217575163595,9.417774401414135,10.149513811835277,16.42644733709858.108523438493648,1.434502126261577-.608464364560859,2.804207106320973-1.848574047402508,3.533838426536022-6.057783079721048,3.56333963162615-13.2208123291839,4.201305201275318-19.281228009638653,1.03096663688666-6.060418192471843-3.170339569198404-9.622177447234208-9.41830041915091-10.149513811815268-16.426447839497996Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2385",
    className: "cls-1",
    d: "m73.689529516799666,97.565612272714134l-23.093750333706339-10.712671318837238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2389",
    className: "cls-1",
    d: "m74.179313829050443,48.68862360977073v75.889742741725058"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.56787658154644,
    y1: 125.68281755419048,
    x2: 107.83494874313874,
    y2: 125.68281755419048
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "86.215699999998833 34.455148211731284 103.417143932365434 17.188894409628119 121.088363175455015 17.188894409628119"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "84.28499095065672 88.352366903160146 92.814412386511322 106.575811747597982 121.088363175455015 106.575811747597982"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 134.34177760777493,
    cy: 17.18889440962812,
    r: 13.253414432319003
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 134.34177760777493,
    cy: 106.57581174759844,
    r: 13.253414432318776
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "128.979564329971254 15.090437124512391 133.544629301102759 21.017658578964983 151.091564912892864 5.239018039867005"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "128.979564329971254 104.046475671742883 133.544629301102759 109.973697126193656 151.091564912892864 94.195056587097497"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.12510466288768,
    y1: 69.47323669225807,
    x2: 40.12510466288768,
    y2: 38.868261293069736
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m38.616544282105679,14.089301195130247l-12.649097837687805,21.908880124781717c-.670471280349375,1.161290322581408.167617820086889,2.612903225806804,1.508560380785639,2.612903225806804h25.29819567537379c1.34094256069875,0,2.179031661135014-1.451612903223577,1.508560380785639-2.612903225804985l-12.649097837685986-21.908880124783536c-.670471280351194-1.161290322579589-2.346649481221903-1.161290322579589-3.017120761571277,0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.12510466289132,
    y1: 21.30601367329291,
    x2: 40.12510466289132,
    y2: 29.078915129730376
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.12510466289132,
    y1: 32.17543684814882,
    x2: 40.12510466289132,
    y2: 33.34453178265176
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon01.29bfb6d25019f424ac63127862528eaa.svg";
export { ForwardRef as ReactComponent };